export default __webpack_public_path__ + "static/media/O3.bf9d9327.png";